interface QuotasModel {
   reviews: number;
   reviewers: number;
}

export const nullQuotasModel = (): QuotasModel => ({
   reviews: 0,
   reviewers: 0
});

export default QuotasModel;
